<template>
  <div style="text-align: left;">
    <el-form inline>
      <el-form-item label="面单尺寸">
        <el-select v-model="formInline.size">
          <el-option label="全部" :value="undefined"></el-option>
          <el-option :label="`${item.width}*${item.height}`" :value="index" v-for="(item, index) in sheetSizeList"
            :key="index"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="打印机名称">
        <el-input v-model="formInline.printer"></el-input>
      </el-form-item>
      <el-form-item label="状态">
        <el-select v-model="formInline.isOpen">
          <el-option label="全部" :value="undefined"></el-option>
          <el-option label="开启" :value="1"></el-option>
          <el-option label="关闭" :value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="search">搜索</el-button>
        <el-button @click="reset">重置</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { sheetSizeList } from "./InterListData.js"
export default {
  name: "InterForm",
  props: {
  },
  data() {
    return {
      formInline: {
        size: "",
        printer: '',
        isOpen: ''
      },
      sheetSizeList
    };
  },
  created() {
    this.$emit("querySubmit", this.formInline);
  },
  methods: {
    search() {
      let params = {
        isOpen: this.formInline.isOpen,
        printer: this.formInline.printer,
      }
      if (this.formInline.size || this.formInline.size === 0) {
        params.printPaperSizeHigh = this.sheetSizeList[this.formInline.size].height,
          params.printPaperSizeWide = this.sheetSizeList[this.formInline.size].width
      }
      this.$emit('querySubmit', params)
    },
    reset() {
      Object.keys(this.formInline).forEach(i => this.formInline[i] = '')
      this.$emit("querySubmit", this.formInline);
    }
  }
};
</script>

<style scoped>
.demo-form-inline {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: wrap;
}
</style>
